import React, { Fragment, useState } from 'react';
import { css } from 'twin.macro';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { BsCheckLg } from 'react-icons/bs';
import { VscLoading } from 'react-icons/vsc';
import { approveExpense } from '@/_services/api/expense';

const ModalCSS = css`
    .modal-header {
        color: white;
        background: #50aeb0;
        button {
            color: white;
        }
    }
    .modal-body {
        padding: 1.5rem;
    }
    .form-label {
        font-weight: 600;
        color: #333;
        margin-bottom: 0.5rem;
    }
    .expense-info {
        background-color: ##50aeb0;
        border: 1px solid ##50aeb0;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1rem;
    }
    .expense-amount {
        font-size: 1.2rem;
        font-weight: bold;
        color: #50aeb0;
    }
`;

const ExpenseApproveModal = ({ expense, handleUpdateExpense }) => {
    const [isBusy, setIsBusy] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const handleApproveExpense = async (expenseId) => {
        try {
            setIsBusy(true);
            const response = await approveExpense({ expenseId });
            handleUpdateExpense(response);

            toast.success('Expense approved successfully');
            handleClose();
        } catch (error) {
            toast.error(error.message || 'Failed to approve expense');
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <Fragment>
            <BootstrapToolTip text="Approve">
                <BsCheckLg className="icon assign" onClick={handleOpen} />
            </BootstrapToolTip>
            <Modal show={isOpen} onHide={handleClose} css={ModalCSS}>
                <Modal.Header closeButton>
                    <Modal.Title>Approve Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        disabled={isBusy}
                        onClick={() => {
                            handleApproveExpense(expense._id);
                        }}
                    >
                        {isBusy ? <VscLoading className="spin" /> : 'Approve Expense'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default ExpenseApproveModal;
